import { useMemo } from 'react';
import CtaBand from '@/components/feature/CtaBand';
import SiteLayout from '@/components/feature/SiteLayout';
import { useSeo } from '@/hooks/useSeo';
import CategoryGrid from '@/pages/home/components/CategoryGrid';
import ChecklistSection from '@/pages/home/components/ChecklistSection';
import FaqPreview from '@/pages/home/components/FaqPreview';
import FeaturedArticles from '@/pages/home/components/FeaturedArticles';
import Hero from '@/pages/home/components/Hero';
import LatestArticles from '@/pages/home/components/LatestArticles';
import VictimVoices from '@/pages/home/components/VictimVoices';
import { faqs } from '@/mocks/faqs';
import { siteConfig } from '@/mocks/site';

export default function Home() {
  const jsonLd = useMemo(
    () => [
      {
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        name: siteConfig.fullName,
        description: siteConfig.intro,
        inLanguage: 'zh-CN',
      },
      {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: siteConfig.fullName,
        description: '专注跨境诈骗内幕曝光与反诈科普的中文内容站。',
        email: siteConfig.email,
      },
      {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: faqs.map((item) => ({
          '@type': 'Question',
          name: item.q,
          acceptedAnswer: { '@type': 'Answer', text: item.a },
        })),
      },
    ],
    [],
  );

  useSeo({
    title: '缅北黑料 · 反诈内幕档案库｜诈骗园区、电诈窝点与骗局起底',
    description:
      '缅北黑料反诈内幕档案库，聚合缅北诈骗园区、电诈窝点、虚假投资与高薪招聘骗局的深挖内容，提供受害者经历与园区运作线索，帮你认清骗局套路，远离跨境陷阱。',
    keywords: '缅北黑料,缅北黑料诈骗园区,缅北黑料电诈,缅北黑料窝点,缅北黑料骗局,缅北黑料内幕',
    path: '/',
    jsonLd,
  });

  return (
    <SiteLayout>
      <Hero />
      <CategoryGrid />
      <FeaturedArticles />
      <VictimVoices />
      <ChecklistSection />
      <LatestArticles />
      <FaqPreview />
      <CtaBand />
    </SiteLayout>
  );
}